import { CommonModule } from "@angular/common";
import { Component, Input } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { SportsTitleCasePipe } from "@sports-pipes/index";

@Component({
  selector: "sports-grid-content-single",
  templateUrl: "./sports-grid-content-single.html",
  styleUrls: ["./sports-grid-content-single.scss"],
  standalone: true,
  imports: [SportsTitleCasePipe, CommonModule, FormsModule],
})
export class SportsGridContentSingleComponent {
  @Input() title;
  @Input() subtitle;
  @Input() countryCode: string = null;
  titleBet: string;
}
